import styled from "styled-components";
import COLORS from "../../constants/colors";

export const WholeWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
`;

export const MainContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  flex-grow: 1;
  background: ${COLORS.primary.oxford}78;
  display: flex;
  flex-direction: column;
`;
